import { render } from "./HomePage.vue?vue&type=template&id=3f2217d9"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__